<template>
	<wrapper-readonly-modes
		:blockDefinitions="blockDefinitions"
		:blocks="blocks"
		:canStartPresenterMode="canStartPresenterMode"
		canvasClass="p-block-activity-canvas"
		:defaultBlockStyles="defaultBlockStyles"
		:globalVariables="globalVariables"
		:leftPanelsBottom="leftPanelsBottom"
		:leftPanelsTop="leftPanelsTop"
		modeClass="lp-index-activity"
		:rightPanels="rightPanels"
		:settingStyles="settingStyles"
		:slideId="slideId"
		@submitQuiz="onSubmitQuiz"
		@selectSlideById="onSelectSlideById"
		@goToBookmarkTarget="onGoToBookmarkTarget"
		@slideChanged="onSlideChanged"
	>
		<template #toolbar>
			<activity-toolbar />
		</template>
	</wrapper-readonly-modes>
</template>

<script>
import ActivityToolbar from './ActivityToolbar.vue';
import WrapperReadonlyModes from '../WrapperReadonlyModes.vue';

export default {
	name: 'BlockActivity',
	inject: ['lessonPlanController'],
	components: {
		ActivityToolbar,
		WrapperReadonlyModes
	},
	props: {
		blocks: Array,
		slideId: String,
		blockDefinitions: Object,
		defaultBlockStyles: Object,
		settingStyles: Object,
		leftPanelsTop: Array,
		leftPanelsBottom: Array,
		rightPanels: Array,
		globalVariables: Array,
		canStartPresenterMode: Boolean
	},
	mounted() {
		document.addEventListener('goToFollowingSlide', this.goToFollowingSlide);
	},
	unmounted() {
		document.removeEventListener('goToFollowingSlide', this.goToFollowingSlide);
	},
	methods: {
		onSelectSlideById(id) {
			this.$emit('selectSlideById', id);
		},
		onGoToBookmarkTarget(bookmark) {
			this.$emit('goToBookmarkTarget', bookmark);
		},
		onSlideChanged(blocksSelector) {
			this.$emit('slideChanged', blocksSelector);
		},
		onSubmitQuiz(quiz) {
			this.lessonPlanController.submitQuiz(quiz);
		},
		goToFollowingSlide(event) {
			const parentQuiz = this.lessonPlanController.getParentQuiz(this.lessonPlanController.navigation.selectedSlide);
			if (parentQuiz) {
				this.blocksSelector.closeAllOverlays();
				const index = this.lessonPlanController.navigation.slidesVisible.findIndex(
					slideA => slideA.id === event.detail.id
				);
				if (this.lessonPlanController.isQuizFinished(parentQuiz)) {
					const resultsIndex = this.lessonPlanController.navigation.slidesVisible.findIndex(
						(slideA, i) => i >= index && slideA.type === 'ResultsSlideTemplate'
					);
					this.lessonPlanController.navigation.selectSlideByIndex(resultsIndex);
				} else {
					this.lessonPlanController.navigation.selectSlideByIndex(index + 1);
				}
			}
		}
	}
};
</script>

<style>
.lp-index-activity .lp-index-panel {
	top: 38px;
}

.lp-index-activity .lp-index-main {
	top: 38px;
}
</style>
